export class NoNetworkError extends Error {
    constructor(message) {
        super(message);
        this.noNetworkError = true;
        this.errorCode = 999999
    }
}
